'use strict';

import $ from 'jquery';

if ($('.standard-page-content').length) {
	let tagBox = $('.standard-page-content .tags-wrapper');
	if (!tagBox.text().trim()) {
		tagBox.hide();
	}
}